import { useLocation } from 'react-router-dom'
import { Card } from 'antd'
import ForgotPasswordForm from './components/ForgotPasswordForm'

type ForgotPasswordLocationState = {
  email?: string
  info?: string
} | null

export default function ForgotPasswordPage() {
  const location = useLocation()
  const state = location.state as ForgotPasswordLocationState

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-brand-50/40 flex items-center justify-center p-6">
      <Card className="w-full max-w-md border border-brand-100 shadow-card">
        <h1 className="font-display text-2xl font-bold text-gray-900 mb-1">Forgot Password</h1>
        <p className="text-sm text-gray-500 mb-5">Enter the email linked to your account.</p>
        <ForgotPasswordForm initialEmail={state?.email} initialInfo={state?.info} />
      </Card>
    </div>
  )
}
